import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=e70463f2&"
import script from "./LanguageSelection.vue?vue&type=script&lang=js&"
export * from "./LanguageSelection.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports